import React from "react";
import { Flex } from "@fluentui/react-northstar";
import StatusContainer from "../../../components/molecules/StatusContainer";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import CallingContainer from "../../molecules/CallingContainer";
import { useMst } from "../../../hooks/useMst";

const MyStatusContentComponent = observer((props) => {
  const {
    statusDropdownItems,
    currentUser,
    onChange,
    currentCallTeamId,
    setCurrentCallTeam,
  } = props;

  const { permissionStore } = useMst();

  const hasCallManagerPermissions = permissionStore.havePermissions("Call Manager", [
    "TeamCall",
  ]);

  const hasOuboundDialPermissions = permissionStore.havePermissions("Outbound Dial Destination", [
    "ObddUpdt"
  ]);

  const callingContainer =
    currentUser.agent.registered &&
      hasCallManagerPermissions &&
      hasOuboundDialPermissions &&
      currentUser.agent.loggedInTeams.length > 0 ? (
      <CallingContainer
        teams={currentUser.agent.loggedInTeams}
        currentStatusCode={currentUser.agent.statusCode}
        setCurrentCallTeamId={setCurrentCallTeam}
        currentCallTeamId={currentCallTeamId}
      />
    ) : null;

  return (
    <Flex data-testid="myStatusContent" gap="gap.large" wrap>
      <StatusContainer
        statusDropdownItems={statusDropdownItems}
        currentStatusCode={currentUser.agent.statusCode}
        currentReasonCode={currentUser.agent.reasonCode}
        currentStateChangeTime={currentUser.agent.statusChangeTime}
        onChange={onChange}
      />
      {callingContainer}
    </Flex>
  );
});

MyStatusContentComponent.propTypes = {
  statusDropdownItems: PropTypes.array,
  currentUser: PropTypes.object,
  onChange: PropTypes.func,
  currentCallTeamId: PropTypes.number,
  setCurrentCallTeam: PropTypes.func,
};

MyStatusContentComponent.defaultProps = {
  statusDropdownItems: [],
};

export default MyStatusContentComponent;
